// =============================================================================
// Brand Constants — app.smart IDV (Identidade Visual)
// =============================================================================
// Fonte única de verdade para cores, gradientes e configurações de marca.
// Todos os componentes devem importar daqui em vez de usar hardcode.
// Referencia: /app-smart.html (Brand System Final)
// =============================================================================

// --- Cores principais da marca ---
export const BRAND_PRIMARY = '#9B2C2C'; // Red 700 — cor principal
export const BRAND_SECONDARY = '#BE185D'; // Pink 700 — cor secundaria
export const BRAND_ACCENT = '#EC4899'; // Pink 500 — acento / hover
export const BRAND_DARK = '#5D1A1A'; // Bordo profundo
export const BRAND_LIGHT = '#F472B6'; // Pink 400 — uso em dark mode

// --- Gradiente principal ---
export const BRAND_GRADIENT =
  'linear-gradient(135deg, #9B2C2C 0%, #BE185D 100%)';
export const BRAND_GRADIENT_CSS = {
  from: '#9B2C2C',
  to: '#BE185D',
  angle: 135,
};

// --- Paleta woot (Tailwind) ---
export const WOOT_PALETTE = {
  25: '#FEF2F2',
  50: '#FEE2E2',
  75: '#FECDD3',
  100: '#FECACA',
  200: '#FCA5A5',
  300: '#F87171',
  400: '#EF4444',
  500: '#DC2626',
  600: '#B91C1C',
  700: '#9B2C2C',
  800: '#7F1D1D',
  900: '#5D1A1A',
};

// --- Cores semanticas para charts/reports ---
// IDV Smart² (SMART2-APLICAR-IDV.md): semanticas fixas, burgundy nunca
// colore metrica — vira tom de categoria/decoracao.
export const CHART_COLORS = {
  primary: '#6b8aaf',
  secondary: '#a08968',
  accent: '#c4a882',
  positive: '#22c55e',
  negative: '#ef4444',
  warning: '#f59e0b',
  info: '#6b8aaf',
  neutral: '#9a8e88',
  violet: '#7a2f2b',
  amber: '#f59e0b',
};

// Paleta sequencial para donut/pie charts (ate 10 itens)
export const CHART_PALETTE = [
  '#6b8aaf', // info
  '#22c55e', // positive
  '#f59e0b', // warning
  '#c4a882', // gold
  '#7a2f2b', // burgundy claro (categoria)
  '#4ade80', // positive light
  '#d4be9e', // gold light
  '#8fa8c4', // info light
  '#a08968', // gold dark
  '#ef4444', // negative (ultimo)
];

// --- Paleta para bar charts (main + comparison) ---
export const BAR_COLORS = {
  main: '#6b8aaf',
  comparison: '#d4be9e',
  hover: '#c4a882',
};

// --- Tooltip padrao para Chart.js ---
export const CHART_TOOLTIP_STYLE = {
  enabled: true,
  backgroundColor: 'rgba(15, 23, 42, 0.95)',
  titleColor: 'rgba(248, 250, 252, 1)',
  bodyColor: 'rgba(226, 232, 240, 1)',
  borderColor: 'rgba(51, 65, 85, 1)',
  borderWidth: 1,
  cornerRadius: 8,
  padding: 12,
  boxPadding: 4,
  caretSize: 6,
  caretPadding: 8,
  titleFont: { size: 13, weight: '600' },
  bodyFont: { size: 12 },
};

// --- Formularios ---
export const FORM_PRIMARY_COLOR = '#9B2C2C';

// --- Click ID labels (UTM attribution) ---
export const CLICK_ID_LABELS = {
  gclid: 'Google Ads',
  gbraid: 'Google Ads (App)',
  wbraid: 'Google Ads (Web)',
  dclid: 'Google DV360',
  fbclid: 'Facebook',
  fbc: 'Facebook Conv.',
  fbp: 'Facebook Pixel',
  ctwa_clid: 'WhatsApp CTWA',
  leadgen_id: 'Meta Lead Ads',
  ttclid: 'TikTok',
  li_fat_id: 'LinkedIn',
  msclkid: 'Microsoft Ads',
  twclid: 'Twitter/X',
  epik: 'Pinterest',
  ScCid: 'Snapchat',
  sck: 'Snapchat (alt)',
  rdt_cid: 'Reddit',
};
